module.exports = __webpack_public_path__ + "img/shiba-body-level5.fd5c39aa.png";